enum Recursos {
    INICIO = 'VISTA_EMPRESA',
    INICIO_TRABAJADOR = 'VISTA_TRABAJADOR',
    MIS_SINIESTROS = 'MIS_SINIESTROS',
    CAPACITACIONES_ELEARNING = 'CAPACITACIONES_ELEARNING',
    RESULTADOS_EXAMENES_SALUD = 'EXAMANES_DE_SALUD',
    ESTADOS_DE_PAGOS = 'BOTON_ESTADOS_DE_PAGOS_TRABAJADOR',
    MUNDO_ACHS_TRABAJADOR = 'MUNDO_ACHS',
    MI_PERFIL = 'DATOS',
    EMPRESAS_VINCULADAS = 'MIS_SOLICITUDES',
    TOUR_GUIADO = 'TOUR_GUIADO',
    MATERIAL_SOPORTE = 'MATERIAL_SOPORTE',
    NECESITAS_AYUDA = 'NECESITAS_AYUDA',
    DATOS_EMPRESA = 'DATOS_EMPRESA',
    COTIZACIONES = 'COTIZACIONES',
    CERTIFICADOS_EMPRESA = 'CERTIFICADOS',
    DECRETO_SUPREMO_67 = 'DECRETO_SUPREMO_N_67',
    DEVOLUCIONES = 'DEVOLUCIONES',
    MUNDO_ACHS_EMPRESA = 'MUNDO_ACHS_EMPRESA',
    GESTION_USUARIOS = 'GESTIONAR_USUARIOS',
    GESTION_CURSOS_ELEARNING = 'GESTION_CURSOS_ELEARNING',
    ACHS_GESTION = 'ACHS_GESTION',
    AGENDAMIENTO_EXPERTO = 'AGENDAMIENTO_EXPERTO',
    LESIONES_GRAVES_FATALES = 'LESIONES_GRAVES_Y_FATALES',
    PLAN_MOVILIDAD = 'PLAN_MOVILIDAD',
    PLATAFORMA_PSICOSOCIAL = 'PLATAFORMA_PSICOSOCIAL',
    AUTOEVALUACION_LEGAL = 'AUTOEVALUACION_LEGAL',
    TMERT = 'TMERT',
    SAC = 'SAC',
    SINIESTROS_EMPRESA = 'SINIESTROS',
    DENUNCIAS = 'DENUNCIAS',
    ESTADISTICAS = 'ESTADISTICAS',
    PRESTACIONES_ECONOMICAS = 'PRESTACIONES_ECONOMICAS',
    COVID_19 = 'COVID',
    SEL = 'BOTON_SEL',
    MANTENEDOR_SEL = 'BOTON_MANTENEDOR_SEL',
    LINK_FORMULARIO_QUALTRICS = 'LINK_FORMULARIO_QUALTRICS',
    SOPORTE_DE_USUARIOS = 'BOTON_SOPORTE_DE_USUARIOS_TRABAJADOR',
    CITAS_MEDICAS = 'CITAS_MEDICAS',
    SWITCH_MUNDO_PREVENTIVO = 'SWITCH_MUNDO_PREVENTIVO',
    ENTERPRISE_DATA_EDIT_BUTTON = 'ENTERPRISE_DATA_EDIT_BUTTON',
    ENTERPRISE_CONTACT_EDIT_BUTTON = 'ENTERPRISE_CONTACT_EDIT_BUTTON'
}

export default Recursos;
